export default "__VITE_ASSET__D_xoPHCi__"